'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

var Options = function (_a) {
    var items = _a.items;
    return (React__default.createElement(React__default.Fragment, null, items.map(function (item) { return (React__default.createElement("option", { key: item.value, value: item.value, "data-cy": "option-" + item.value, "data-testid": "option-" + item.value }, item.label)); })));
};

exports.Options = Options;
